/**
 * This is a wrapper component for different Layouts.
 * Topbar should be added to this wrapper.
 */
import React, { FC, ReactNode } from 'react';

interface LayoutWrapperTopbarProps {
  children: ReactNode;
}

const LayoutWrapperTopbar: FC<LayoutWrapperTopbarProps> = ({ children }) => <>{children}</>;

export default LayoutWrapperTopbar;
